import { render, staticRenderFns } from "./LayerCatalogue.vue?vue&type=template&id=3869a38d"
import script from "./LayerCatalogue.vue?vue&type=script&lang=js"
export * from "./LayerCatalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports